import { Expand } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ExpandIcon = createLucideIcon(Expand);
